// UserPlanTypes.js
export const GET_USER_PLANS_PENDING = 'GET_USER_PLANS_PENDING';
export const USER_PLANS = 'USER_PLANS';
export const GET_USER_PLAN_PENDING = 'GET_USER_PLAN_PENDING';
export const USER_PLAN = 'USER_PLAN';
export const UPDATE_USER_PLAN = 'UPDATE_USER_PLAN';
export const UPDATE_USER_PLAN_PENDING = 'UPDATE_USER_PLAN_PENDING';
export const CREATE_USER_PLAN = 'CREATE_USER_PLAN';
export const CREATE_USER_PLAN_PENDING = 'CREATE_USER_PLAN_PENDING';
